import { DestroyRef, effect, inject, Injectable, Injector, runInInjectionContext, signal } from '@angular/core';

import type { ILandingPage } from 'src/pages/layouts/entities/types';

export interface IPromoInstrumentEvent {
    id: string | number | null;
    data?: ILandingPage;
    type?: string;
}

@Injectable({
    providedIn: 'root',
})
export class PromoInstrumentService {
    private readonly destroyRef = inject(DestroyRef);
    private readonly injector = inject(Injector);
    public readonly activePromoInstrument = signal<IPromoInstrumentEvent | null>(null);

    public trigger(promoEvent: IPromoInstrumentEvent): void {
        this.activePromoInstrument.set(promoEvent);
    }

    public observePromoInstrument(id: string | number, callback: (data?: IPromoInstrumentEvent) => void): void {
        const effectRef = runInInjectionContext(this.injector, () => {
            return effect(() => {
                const active = this.activePromoInstrument();
                if (active && active.id === id) {
                    callback(active);
                } else if (active === null || active?.id === null) {
                    callback(null);
                }
            });
        });

        this.destroyRef.onDestroy(() => {
            effectRef.destroy();
        });
    }
}
